module.exports = __webpack_public_path__ + "static/media/profile-pic.6ccd9786.jpg";